/**
 * Generates a className string from an object where keys are class names
 * and values are boolean flags indicating whether to include the class
 *
 * @param classMap Object with class names as keys and boolean values
 * @returns Space-separated string of class names
 */
export const generateClassNames = (classMap: Record<string, boolean>): string => {
  return Object.entries(classMap)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(' ');
};
